import React, { useState, useContext } from 'react';
import { UserContext } from '../../../../context/UserContext';
import { Card, CardSegment } from '../../../ui';
import InviteToSpaceModal from './InviteToSpaceModal';
import MemberList from './MemberList';
import { useQuery } from 'react-apollo-hooks';
import {
  AccountMembersQuery,
  AccountMembersQueryVariables
} from '../../../../queries/__generated__/AccountMembersQuery';
import { accountMembersQuery } from '../../../../queries/account';
import { Loading, ErrorScreen } from '../../../utils';

interface AccountMemberListProps {
  account: {
    id: string;
    owner: {
      id: string;
    };
  };
}

const AccountMemberList: React.FC<AccountMemberListProps> = ({ account }) => {
  const [showInviteModal, setShowInviteModal] = useState(false);
  const { user } = useContext(UserContext);

  const { data, loading, error } = useQuery<AccountMembersQuery, AccountMembersQueryVariables>(
    accountMembersQuery,
    { variables: { input: { accountId: account.id } } }
  );
  if (loading) return <Loading />;
  if (error) return <ErrorScreen error={error.message} />;

  const accountMembers = data!.accountMembers;
  const activeMember = accountMembers.filter(member => member.user.id === user.id)[0];
  const userIsAdmin = activeMember.roleType.toUpperCase() === 'ADMIN';

  return (
    <>
      <Card className="mb2">
        <CardSegment className="pa4">
          <div className="flex justify-between items-baseline mb3">
            <h2 className="f5 fw6 mv0">Space Members</h2>

            {userIsAdmin && (
              <button
                className="f7 blue hover-navy"
                onClick={() => setShowInviteModal(true)}
                data-testid="add-member-button"
              >
                Add Member
              </button>
            )}
          </div>

          <ul className="list ma0 pa0" data-testid="account-members-list">
            <MemberList
              account={account}
              accountMembers={accountMembers}
              userIsAdmin={userIsAdmin}
            />
          </ul>
        </CardSegment>
      </Card>

      {showInviteModal && (
        <InviteToSpaceModal closeModal={() => setShowInviteModal(false)} account={account} />
      )}
    </>
  );
};

export default AccountMemberList;
